import {listMenu} from "data/list";
import React from "react";
import {FIELD_TYPE} from "types/enums";

const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Tên role",
    name: "name",
  },
];
const columns: any[] = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Mã SSO",
    dataIndex: "maSso",
    key: "maSso",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Role",
    dataIndex: "name",
    key: "name",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Mô tả",
    dataIndex: "description",
    key: "description",
    show: true,
    isResizable: true,
    align: "left",
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    isResizable: true,
    align: "center",
  },
];
const columnsFunc: any[] = [
  {
    title: "ID",
    dataIndex: "chucNangId",
    key: "chucNangId",
    show: true,
    isResizable: true,
    align: "center",
  },
  {
    title: "Tên",
    dataIndex: "chucNangName",
    key: "chucNangName",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Mô tả",
    dataIndex: "description",
    key: "description",
    show: true,
    isResizable: true,
    align: "left",
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    isResizable: true,
    align: "center",
  },
];
const columnsMenu: any[] = [
  {
    title: "Tên menu",
    dataIndex: "menu",
    key: "menu",
    show: true,
    isResizable: true,
    align: "left",
    render(v, r, i) {
      const name = listMenu?.find(e => e?.value == v)?.label;
      return <div>{name}</div>;
    },
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
    isResizable: true,
    align: "center",
  },
];
export {fields, columns, columnsFunc, columnsMenu};
